import $ from "jquery";

import * as accountModal from "accountModal";
import * as modalDialog from "modalDialog";
import * as signupModal from "signupModal";

export default function (response, models, notify?, dismissNotification?) {
  if (response.data?.error) {
    switch (response.data.error) {
      case "notSignedIn":
        signupModal.show({
          headingHtml: "<h2>Sign in to translate <strong>phrases</strong></h2>",
          models: models,
        });
        break;
      case "dailyLimit":
        if (models.user.hasPremiumAccess()) {
          alert(
            "You have reached a rate limit designed to prevent abuse of the service. If you " +
              "have hit this limit by normal use, please let me know at steve@readlang.com"
          );
        } else {
          accountModal.show({
            model: models.user,
            title: "phraseLimit",
            phraseLimit: true,
            messageHtml: "<h2>Get unlimited phrase translations...</h2>",
            showTitle: false,
          });
        }
        break;
      case "tooManyCharacters":
        notify?.({
          message: "Limit of 30 characters per phrase",
          element: $(".container"),
        });
        break;
      case "phraseLengthLimit": {
        let phraseLengthLimit;
        let upsell = "";

        if (
          /^(standard|freeForever|plus)$/.test(
            models.user.get("subscriptionPlan")
          )
        ) {
          phraseLengthLimit = 12;
        } else {
          phraseLengthLimit = 6;
          upsell =
            '<br><a href="#" id="phraseLengthUpsell"><i class="icon-rocket"></i> ' +
            "Increase to 12 words" +
            "</a>.";
        }

        notify?.({
          htmlMessage:
            "Limit of " + phraseLengthLimit + " words per phrase. " + upsell,
          element: $(".container"),
          time: 8000,
          callback: () => {
            $("#phraseLengthUpsell").click((event) => {
              event.preventDefault();
              event.stopPropagation();
              accountModal.show({
                model: models.user,
                title: "phraseLengthLimit",
                messageHtml: "<h2>Upgrade to increase phrase length limit</h2>",
                showTitle: false,
              });
              dismissNotification?.();
            });
          },
        });
        break;
      }
      default: {
        const messageElement = $("<div/>")
          .append("<h2>Translate Error</h2>")
          .append($("<p/>").text(response.data.error));
        modalDialog.show(
          $("<div/>").addClass("centralDialog").append(messageElement)
        );
      }
    }
  }
}
